<template>
  <div>
    <app-header />
    <div class="container-fluid">
      <div class="content my-4">
        <div class>
          <slot />
        </div>
      </div>
    </div>
    <app-footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "LayoutUser",

  components: {
    "app-header": Header,
    "app-footer": Footer
  },

  data() {
    return {
      user: null
    };
  },

  computed: {
    // ...mapState(["currentUser"])
  }
};
</script>
